module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "a18"
    }
  }), _vm._v("Monday, October 22, 1990")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“Hi, Sully. It’s me. Lou. But yeah, you can hear that of course. I…uh…know I shouldn’t call you, but…I had to hear your voice, even if it’s just only your answering machine message. I’m…”")]), _vm._v("—drawn-out, despondent sigh—"), _c('span', {
    staticClass: "t6"
  }, [_vm._v("“I’m so fucking sorry, you have no idea. I wish I was brave like you but I’m not. I’m sorry for letting you down. For letting you go. So, so sorry.”—")]), _vm._v("half-swallowed sob followed by heavy breathing—"), _c('span', {
    staticClass: "t6"
  }, [_vm._v("“I…guess I should hang up. I just…I love you, you know? I guess I’m like that poet fellow you told me about. Donne? Two kinds of fool? But instead of being in love and talking about it in a poem, I’m letting the one I love go. That’s gotta be worse, huh? Take care, Sully. I…uh…“")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("My legs give up underneath me as I listen to the message, and I sink onto the chair and lean my forehead on the kitchen table with a loud groan. When the machine beeps, I rewind the tape and listen to the message again. And again.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("I just love you, you know.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I repeatedly bang my head against the table as I listen to it a fourth time, my heart aching more and more with every repeat. With every time I hear that half-swallowed sob.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Ouch,” I yelp after a too-hard thump, and rub my sore forehead with fingertips still stiff after the outdoor chill. “And you "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("had")]), _vm._v(" to quote John Donne to me, you dickhead,” I mutter and shove my hands under my thighs so I won’t replay the message a fifth time.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I didn’t know Lou paid that much attention to me when I read poetry around him. He’s the kind of person who prefers beer over books and paintball over poetry and is constantly in movement even when he’s supposed to be still; legs jiggling or fingers drumming a tattoo on his leg, or he’s tossing and catching his ever-present baseball.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("So to hear that Lou actually listened to me when I read aloud my beloved poetry around him prickles my heart. I always thought he tuned me out and focused on something else, or at least not focusing on the actual words and taking in what I was reading. He never mentioned it after he caught me doing it the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You’re reading out loud,” he said when he found me with my coffee, a lit candle, and whatever poetry book I’d checked out of the library the first time he spent the night in my tiny apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He startled me, but I nodded. “Yes. I like to hear the words, not just in my head. I want to know what they feel like in my mouth. Does it bother you?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Nah,” Lou said and kissed me on the mouth, morning breath and all since the sleepover was unplanned and he hadn’t brought a toothbrush.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("After that, I continued reading the poems out loud around him, thinking he wasn’t listening anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Seems I was wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("But it wasn’t the only thing I was wrong about. I also thought that when someone said “I love you,” it meant that they wanted to "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("be")]), _vm._v(" with the other person, but that’s obviously wrong, too. At least if the person saying the words is named Lou Hillman.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Abruptly, I stand and slam my hand on the DELETE button, strip out of my running clothes, and jump into the shower.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af0d7b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0